<template>
  <div class="protocol_container">
    <div class="protocol_box">
      <h2 style="text-align: center; padding: 1em 0 1em">
        <span style="color: black">“{{appFullName}}”用户协议</span>
      </h2>
      <div class="content_box">
        一. 服务条款的确认和接纳<br>
        用户注册前，请认真阅读本协议。一经注册，即视为同意接受本协议；如不同意，请勿注册。您必须在完全同意如下条款的前提下，才能进行注册程序。用户在享受农民日报客户端服务时必须完全、严格遵守本服务条款。<br>
        二. 服务条款的完善和修改<br>
        农民日报客户端根据互联网的发展和中华人民共和国有关法律、法规的变化，不断地完善服务质量并依此修改农民日报客户端服务条款。用户的权利以及义务的表述，均以最新的服务条款为准。农民日报客户端保留随时修改或中断服务而不通知您的权利，农民日报客户端行使修改或中断服务的权利，不需要对您或第三方负责。<br>
        三. 拒绝提供担保<br>
        1. 您须明确同意农民日报客户端所有网络平台的使用由您个人承担风险。农民日报客户端明确表示不提供任何类型的担保，不论是明确的或隐含的。<br>
        2. 农民日报客户端不担保所提供的服务一定能满足您的要求，也不担保服务不会中断，对服务的及时性、安全性、错误发生都不作担保。农民日报客户端拒绝提供任何担保，包括信息能否准确、及时、顺利的传送。<br>
        3. 您理解并接受任何信息资料(下载或通过服务取得)，取决于您自己并由您承担系统受损或资料丢失的所有风险和责任。您不会从农民日报客户端收到口头或书写的意见或信息，也不会在这里作明确担保。<br>
        四. 免责条款<br>
        1. 农民日报客户端对任何直接、间接、偶然、特殊及继起的损害不负责任，不予赔偿。这些损害来自：网络故障，不正当下载、使用农民日报客户端服务内容；在网上购买商品或类似服务；在网上进行交易，非法使用服务等。<br>
        2. 用户应对自己在农民日报客户端上发表的内容负全部责任，并承诺提交的个人资料真实可靠。<br>
        3. 对于因服务器的死机、网络的故障、数据库故障、软件升级等问题造成的服务中断、农民日报客户端不负责任，亦不予补偿。<br>
        4. 当政府司法机关依照法定程序要求本客户端披露个人资料时，我们将根据执法单位之要求或为公共安全之目的提供个人资料。在此情况下之任何披露，本客户端均得免责。<br>
        5. 用户定制增值服务后，服务期间含服务器维修、调整、升级时间，农民日报客户端对服务器维修、调整、升级所占用的时间，不予补偿并保留解释权。<br>
        五. 关于中断或终止服务<br>
        1. 因发生不可抗拒的事由，如政府行为、不可抗力，导致服务无法继续提供，农民日报客户端将尽快通知您，但不承担由此对您造成的任何损失。<br>
        2. 如用户违反被服务条款中的内容，农民日报客户端有权取消用户的资格，并中止向其继续提供服务。<br>
        六. 服务内容的版权<br>
        农民日报客户端提供的服务内容（包括但不限于：文字、照片、图形、图像等〕，均受版权保护：由农民日报客户端版权所有，或由第三方授权使用。用户不能擅自复制、再造这些内容、或创造与内容有关的派生产品。凡以任何方式登录本客户端或直接、间接使用本网站资料者，视为自愿接受本客户端协议的约束。本协议未涉及的问题参见国家有关法律法规，当本协议与国家法律法规冲突时，以国家法律法规为准。本协议以及其修改权、更新权及最终解释权均属农民日报社所有。<br>
        1. 制定本协议的目的在于维护本客户端秩序，保障客户端用户的合法权益。<br>
        2. 制定本协议的依据是国家有关法律、法规，当本协议与国家法律、法规冲突时，以国家法律、法规为准。<br>
        3. 用户愿意接受本协议，方可注册，成为本客户端正式用户。<br>
        七. 用户的权利与责任<br>
        1. 用户享有客户端用户的各种权利，可享受客户端提供的各项服务。<br>
        2. 用户在客户端所进行的所有活动应遵守本客户端管理协议，遵守中华人民共和国法律、法规，并自行承担因从事论坛活动直接或间接引起的一切法律责任。<br>
        3. 用户要注意保管好用户名及密码，用户如发现帐号遭他人非法使用，应立即通知客户端管理者。因黑客行为或用户保管疏忽导致帐号、密码遭他人非法使用，农民日报不承担任何责任。<br>
        4. 用户认为自己在客户端的权益受到侵害，有权根据客户端相关规定进行投诉申诉。<br>
        5. 用户有权对客户端管理提出批评、意见、建议，有权就客户端相关管理工作提出异议。<br>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { loadStat } from "@/utils";
import commApi from "@/api/apis/common.js";
export default {
  name: "Protocol",
  data() {
    return {};
  },
  computed: {
    ...mapState("app", ["nodeCode", "appFullName"]),
  },
  methods: {
    /* 微信二次分享 */
    wechatShare() {
      var _this = this;

      commApi.getWeiXinTicket({
        nodeCode: _this.nodeCode,
        url: location.href
      }).then((res) => {
        _this.$WeiXin.shareWeiXin(res, _this.appFullName + "及网站用户协议", _this.appFullName, location.href);
      }).catch((err) => {

      })
    },
  },
  created() {
    document.title = this.appFullName + "及网站用户协议";
    this.wechatShare(); // 微信二次分享
    loadStat(); // 友盟统计
  },
};
</script>
<style scoped lang="scss">
.protocol_container {
  width: 100%;
  height: 100%;
  padding: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  .protocol_box {
    padding: 15px;
    overflow-x: hidden;
    overflow-y: auto;

    * {
      word-break: normal;
      white-space: normal;
      line-height: 1.5em;
    }
    h2 {
      font-size: 18px;
    }
  }
}
</style>